var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"s1-list"},[_c('div',{staticClass:"gray-600 mt-4"},[_c('p',[_vm._v("This is default provider")])])])}]

export { render, staticRenderFns }